<form [formGroup]="skjema" data-testid="skjema">
  <div class="innhold-kontainer">
    <div class="rader">
      @for (kontroller of skjema.controls; track indeks; let indeks = $index; let erSisteRad = $last) {
        <div class="årshjul-innslag-rediger-rad" [class.slettet]="kontroller.value.slettet" data-testid="rad">
          @if (kontroller.value.erArvet) {
            <div class="arvet">{{ 'Arvet fra gruppemal'|translate }}</div>
          }
          <div class="kontainer" [matTooltip]="kontroller.value.erArvet ? ('Tema er arvet fra mal og kan derfor ikke redigeres, kun slettes'|translate) : ''" matTooltipPosition="above">
            <div class="tittel-linje">
              <mat-form-field class="tittel">
                <mat-label>
                  @if (kontroller.value.ny) {
                    {{ 'Nytt innslag' | translate }}
                  } @else {
                    {{ 'Tittel' | translate }}
                  }
                </mat-label>
                <input matInput [formControl]="kontroller.controls.tittel" name="tittel" data-testid="tittel-felt">
                @if (kontroller.controls.tittel.hasError('duplikat')) {
                  <mat-error>{{ 'Tittel må være unik' | translate }}</mat-error>
                }
                @if (kontroller.controls.tittel.hasError('maxlength')) {
                  <mat-error>
                    {{ kontroller.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}
                  </mat-error>
                }
              </mat-form-field>

              <div class="periode" [class.skjult]="erSisteRad">
                <mat-form-field>
                  <mat-label>{{ 'Startuke' | translate }}</mat-label>
                  <input matInput type="number" [formControl]="kontroller.controls.startuke" name="startuke" data-testid="startuke-felt" min="1" max="53">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>{{ 'Antall uker' | translate }}</mat-label>
                  <input matInput type="number" [formControl]="kontroller.controls.antallUker" name="antallUker" data-testid="antallUker-felt" min="1" max="53">
                </mat-form-field>
              </div>

              <div class="handlinger" [class.skjult]="erSisteRad">
                @if (!kontroller.value.slettet) {
                  <button mat-icon-button type="button" (click)="slett(indeks)" aria-label="Slett innslag" data-testid="slett-knapp">
                    <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
                  </button>
                } @else {
                  <button mat-stroked-button type="button" (click)="angreSlett(indeks)">
                    {{ 'Angre' | translate }}
                  </button>
                }
              </div>
            </div>

            @if (!erSisteRad) {
              <div class="beskrivelse">
                <mat-form-field>
                  <mat-label>{{ 'Beskrivelse' | translate }}</mat-label>
                  <riktekst-redigering [skjemakontroll]="kontroller.controls.beskrivelse" data-testid="beskrivelse-felt"/>
                </mat-form-field>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if(viserDiagram()){
      <aarshjul-graf-uten-moeter [data]="aarshjuldata()"/>
    }
  </div>

  <kort-handlinger>
    <button mat-button type="button" (click)="avbryt()">{{ 'Avbryt' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" (click)="lagre()" [disabled]="lagrer() || skjema.invalid" data-testid="lagre-knapp">
      {{ 'Lagre' | translate }}
    </button>
  </kort-handlinger>
</form>
